import styles from "./Banner.module.scss";

const getBannerObjectFit = (uri: string): "cover" | "contain" => {
  try {
    const url = new URL(uri, "https://promofy.local");
    const basename = url.pathname.split("/").pop() || "";

    return basename.startsWith("ai-banner-") ? "contain" : "cover";
  } catch {
    return "cover";
  }
};

type Props = {
  uri: string;
  className?: string;
  bannerTexts?: {
    title: string;
    description?: string;
  } | null;
};

const Banner = ({ uri, className = "", bannerTexts }: Props) => {
  return (
    <div className={`${styles.banner} ${className}`}>
      <img src={uri} alt=" " style={{ objectFit: getBannerObjectFit(uri) }} />
      {bannerTexts && (
        <div className={styles.banner__text}>
          <h2 className={styles.banner__title}>{bannerTexts.title}</h2>
          {bannerTexts.description && (
            <p className={styles.banner__description}>{bannerTexts.description}</p>
          )}
        </div>
      )}
    </div>
  );
};

export default Banner;
